import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import * as ReactHighcharts from "react-highcharts";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import { formatCurrency, formatShortDate } from "utilities";

const SubscriptionsPanel = () => {
  const metrics = useCustomQuery({
    queryKey: ["subscriptionMetrics"],
    queryFn: () => window.CoreApi.AdminOne.SubscriptionMetric().then(res => res.data.data),
    initialData: [],
  });

  return <SectionPanel.Panel
    collapsible={{ start: "closed", uniqueRowId: "subscriptions-panel", persist: true }}
    header={<PanelSegment.Title title={"ARR"} />}
  >
    <ReactHighcharts
      config={{
        chart: {
          style: {
            fontFamily: "inherit"
          },
          type: "column",
          backgroundColor: "transparent"
        },
        series: [
          {
            name: "Annual revenue",
            data: metrics.data?.map(item => item.paidAnnualRevenue) ?? [],
            color: "#4CAF50" // Green 
          }, {
            name: "Monthly revenue",
            data: metrics.data?.map(item => item.paidMonthRevenue) ?? [],
            color: "#2196F3" // Blue 
          }
        ],
        plotOptions: {
          series: {
            stacking: "normal",
            dataLabels: {
              enabled: false
            },

          }
        },
        tooltip: {
          shared: true,
          formatter: function () {
            const total = this.points.reduce((sum, point) => sum + point.y, 0);
            const header = `<b>${this.x}</b>`;

            const body = this.points.map(point => {
              const percentage = ((point.y / total) * 100).toFixed(0);
              return `<br/><span style="color:${point.color}">\u25CF</span> ${point.series.name}: <b>${formatCurrency(point.y, "eur", { hideCents: true })}</b> (${percentage}%)`;
            });

            const footer = `<br/><br/><b>Total: ${formatCurrency(total, "eur")}</b>`;
            return header + body.join("") + footer;
          }
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: metrics.data?.map(item => formatShortDate(item.date)) ?? [],
        },
        yAxis: {
          title: {
            text: "Revenue (EUR)"
          }
        },
        credits: {
          enabled: false
        }
      }}
    />
  </SectionPanel.Panel>;
};

export default SubscriptionsPanel;
